import { Link, useRouterState } from "@tanstack/react-router";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import logo from "@/assets/logo.png";


const nav = [
  { to: "/", label: "בית" },
  { to: "/about", label: "אודות" },
  { to: "/programs", label: "ארגז הכלים" },
  { to: "/support", label: "טיפולים ומענים" },
  { to: "/gallery", label: "גלריה" },
  { to: "/register", label: "הרשמה" },
];

export function SiteHeader() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border/40 bg-background/80 backdrop-blur-md">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src={logo} alt="לוגו תורת חיים" className="h-12 w-12 object-contain" />
          <span className="font-display text-lg font-bold text-primary">מוסדות תורת חיים</span>

        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {nav.map((n) => {
            const active = pathname === n.to;
            return (
              <Link
                key={n.to}
                to={n.to}
                aria-current={active ? "page" : undefined}
                className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  active ? "bg-primary text-primary-foreground" : "text-foreground/80 hover:bg-secondary hover:text-foreground"
                }`}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>

        <button
          onClick={() => setOpen((o) => !o)}
          className="rounded-md p-2 md:hidden"
          aria-label="תפריט"
          aria-expanded={open}
          aria-controls="mobile-menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <nav id="mobile-menu" className="border-t border-border/40 bg-background md:hidden">
          <div className="container mx-auto flex flex-col gap-1 px-4 py-3">
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                aria-current={pathname === n.to ? "page" : undefined}
                className={`rounded-md px-3 py-2 text-sm font-medium ${
                  pathname === n.to ? "bg-primary text-primary-foreground" : "hover:bg-secondary"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
